import type { MapEngine } from "../MapEngine";

/**
 * Toggles the renderer's tile-boundary debug overlay. Thin wrapper over the
 * engine's debug settings so the viewer toggles boundaries without touching
 * the other debug flags (collision boxes, overdraw stay off).
 */
export class TileBoundaryManager {
    private readonly engine: MapEngine;
    private active = false;

    constructor(engine: MapEngine) {
        this.engine = engine;
    }

    isActive(): boolean {
        return this.active;
    }

    setActive(active: boolean): void {
        this.active = active;
        this.engine.setDebugSettings({
            showTileBoundaries: active,
            showCollisionBoxes: false,
            showOverdrawInspector: false,
        });
    }

    toggle(): boolean {
        this.setActive(!this.active);
        return this.active;
    }
}
